module.exports = __webpack_public_path__ + "static/img/21.a892f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/21.jpg
// module id = fL7Q
// module chunks = 16